import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { ConfirmProvider } from "@/components/ConfirmDialog";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import PatientFlow from "@/pages/PatientFlow";
import HomeHub from "@/pages/HomeHub";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Poster from "@/pages/Poster";
import InstapharmApp from "@/pages/instapharm/InstapharmApp";
import InstapharmPro from "@/pages/instapharm/InstapharmPro";
import InstapharmPoster from "@/pages/instapharm/InstapharmPoster";
import InstapharmLegal from "@/pages/instapharm/InstapharmLegal";
import InstapharmCentres from "@/pages/instapharm/InstapharmCentres";
import CentresMedicauxAdmin from "@/pages/instapharm/CentresMedicauxAdmin";
import TeleconsultationSpecialiste from "@/pages/TeleconsultationSpecialiste";
import BilanPrevention from "@/pages/BilanPrevention";
import ServicesUrgences from "@/pages/ServicesUrgences";
import QrCodesAdmin from "@/pages/QrCodesAdmin";
import StaffCalendar from "@/pages/StaffCalendar";
import SpecialtyStats from "@/pages/SpecialtyStats";
import FicheBilanImprimable from "@/pages/FicheBilanImprimable";
import BilansSuivi from "@/pages/BilansSuivi";
import BilanPoster from "@/pages/BilanPoster";
import Contact from "@/pages/Contact";
import Confidentialite from "@/pages/Confidentialite";
import MentionsLegales from "@/pages/MentionsLegales";
import RetirerConsentement from "@/pages/RetirerConsentement";
import ConsentsAdmin from "@/pages/ConsentsAdmin";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ConfirmProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomeHub />} />
            <Route path="/p/:pharmacySlug/bilan-prevention" element={<BilanPrevention />} />
            <Route path="/p/:pharmacySlug/teleconsultation-specialiste" element={<TeleconsultationSpecialiste />} />
            <Route path="/p/:pharmacySlug/services-urgences" element={<ServicesUrgences />} />
            <Route path="/pharmacie" element={<PatientFlow />} />
            <Route path="/instapharm" element={<InstapharmApp />} />
            <Route path="/instapharm/centres" element={<InstapharmCentres />} />
            <Route path="/instapharm/pro" element={<InstapharmPro />} />
            <Route path="/instapharm/affiche" element={<InstapharmPoster />} />
            <Route path="/instapharm/legal" element={<InstapharmLegal />} />
            <Route path="/login" element={<Login />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/retirer-mon-consentement" element={<RetirerConsentement />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
            <Route path="/equipe/fiche-bilan" element={<ProtectedRoute pharmacistOnly><FicheBilanImprimable /></ProtectedRoute>} />
            <Route path="/equipe/bilans" element={<ProtectedRoute pharmacistOnly><BilansSuivi /></ProtectedRoute>} />
            <Route path="/equipe/consentements" element={<ProtectedRoute pharmacistOnly><ConsentsAdmin /></ProtectedRoute>} />
            <Route path="/equipe/centres-medicaux" element={<ProtectedRoute adminOnly><CentresMedicauxAdmin /></ProtectedRoute>} />
            <Route path="/equipe/qr-codes" element={<ProtectedRoute adminOnly><QrCodesAdmin /></ProtectedRoute>} />
            <Route path="/equipe/calendrier" element={<ProtectedRoute><StaffCalendar /></ProtectedRoute>} />
            <Route path="/equipe/statistiques" element={<ProtectedRoute><SpecialtyStats /></ProtectedRoute>} />
            <Route path="/affiche" element={<ProtectedRoute><Poster /></ProtectedRoute>} />
            <Route path="/affiche-bilan" element={<ProtectedRoute><BilanPoster /></ProtectedRoute>} />
            <Route path="*" element={<HomeHub />} />
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
        </ConfirmProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
export default App;
